import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Languages, CheckCircle, XCircle, Loader2 } from 'lucide-react';

const API_BASE = (process.env.REACT_APP_API_URL || 'http://localhost:5000')
    .replace(/\/+$/, '')
    .replace(/\/api$/, '');

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token');
    const [status, setStatus] = useState('loading'); // 'loading' | 'success' | 'error' | 'expired'
    const [message, setMessage] = useState('');

    useEffect(() => {
        if (!token) {
            setStatus('error');
            setMessage('Geçersiz doğrulama bağlantısı.');
            return;
        }

        const verifyToken = async () => {
            try {
                const res = await fetch(`${API_BASE}/api/auth/verify-email?token=${token}`);
                const data = await res.json();
                if (res.ok) {
                    setStatus('success');
                    setMessage(data.message || 'Email başarıyla doğrulandı!');
                } else if (res.status === 410) {
                    setStatus('expired');
                    setMessage(data.error || 'Doğrulama linkinin süresi dolmuş.');
                } else {
                    setStatus('error');
                    setMessage(data.error || 'Doğrulama başarısız.');
                }
            } catch (err) {
                setStatus('error');
                setMessage('Sunucuya bağlanılamadı. Lütfen tekrar deneyin.');
            }
        };

        verifyToken();
    }, [token]);

    const icons = {
        loading: <Loader2 className="w-10 h-10 text-blue-500 animate-spin" />,
        success: <CheckCircle className="w-10 h-10 text-blue-500" />,
        error: <XCircle className="w-10 h-10 text-red-500" />,
        expired: <XCircle className="w-10 h-10 text-amber-500" />,
    };

    const titles = {
        loading: 'Doğrulanıyor...',
        success: 'Email Doğrulandı! 🎉',
        error: 'Doğrulama Başarısız',
        expired: 'Bağlantı Süresi Doldu',
    };

    const bgColors = {
        loading: 'bg-blue-100',
        success: 'bg-blue-100',
        error: 'bg-red-100',
        expired: 'bg-amber-100',
    };

    return (
        <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-green-50 flex items-center justify-center p-4">
            <div className="w-full max-w-md">
                {/* Logo */}
                <div className="flex items-center justify-center gap-2 mb-8">
                    <img src="/logo192.png" alt="CeviriPro Logo" className="w-10 h-10 object-contain drop-shadow-sm" />
                    <span className="text-xl font-bold bg-gradient-to-r from-blue-600 to-green-600 bg-clip-text text-transparent">
                        ÇeviriPro
                    </span>
                </div>

                <div className="bg-white rounded-2xl shadow-xl p-8 text-center">
                    <div className={`w-20 h-20 ${bgColors[status]} rounded-full flex items-center justify-center mx-auto mb-5`}>
                        {icons[status]}
                    </div>

                    <h1 className="text-2xl font-bold text-slate-900 mb-3">{titles[status]}</h1>
                    <p className="text-slate-600 mb-8">{message}</p>

                    {status === 'success' && (
                        <Link
                            to="/login"
                            className="inline-flex items-center gap-2 py-3 px-8 bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-xl font-semibold hover:shadow-lg hover:shadow-blue-500/30 transition-all"
                        >
                            Giriş Yap
                        </Link>
                    )}

                    {(status === 'error' || status === 'expired') && (
                        <div className="space-y-3">
                            <Link
                                to="/login"
                                className="block w-full py-3 bg-gradient-to-r from-blue-600 to-green-600 text-white rounded-xl font-semibold hover:shadow-lg transition-all text-center"
                            >
                                Giriş Sayfasına Git
                            </Link>
                            <p className="text-sm text-slate-500">
                                Doğrulama maili için giriş sayfasında "Doğrulama mailini yeniden gönder" butonunu kullanabilirsiniz.
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default VerifyEmail;
